module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/efo_features_13-6cfea0645c55f69e485f9fcc4370a976.png";